import React, { useId } from "react";

interface BrandLogoProps {
  className?: string;
}

const BrandLogo: React.FC<BrandLogoProps> = ({ className = "h-10 w-auto" }) => {
  const uid = useId().replace(/:/g, "");
  const gradientId = `techGradient-${uid}`;
  const glowId = `neonGlow-${uid}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 450 80"
      className={className}
      role="img"
      aria-label="港微創 HK MicroLaunch"
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#00FF87" />
          <stop offset="100%" stopColor="#60EFFF" />
        </linearGradient>
        <filter id={glowId} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>

      <g transform="translate(10, 10)">
        <path
          d="M 5,45 L 20,15 L 35,35 L 50,10 L 60,30 L 75,5"
          fill="none"
          stroke={`url(#${gradientId})`}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          filter={`url(#${glowId})`}
        />
        <path
          d="M 65,5 L 75,5 L 75,15"
          fill="none"
          stroke={`url(#${gradientId})`}
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          filter={`url(#${glowId})`}
        />
        <circle cx="5" cy="45" r="4" fill="#00FF87" />
        <circle cx="35" cy="35" r="4" fill="#60EFFF" />
      </g>

      <text
        x="105"
        y="42"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Microsoft JhengHei', sans-serif"
        fontSize="26"
        fontWeight="800"
        letterSpacing="1"
        fill="#FFFFFF"
      >
        HK Micro<tspan fill={`url(#${gradientId})`}>Launch</tspan>
      </text>

      <text
        x="107"
        y="62"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Microsoft JhengHei', sans-serif"
        fontSize="13"
        fontWeight="500"
        letterSpacing="4"
        fill="#8A99AD"
      >
        港微創 | AI 港式自動化行銷
      </text>
    </svg>
  );
};

export default BrandLogo;
